import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../design-system/lib/IconProvider';
import Typography from '../../../design-system/lib/Typography';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DeliveryMethod from '../../../assets/IconProvider/DeliveryMethod.svg';
import DropDown from '../../../design-system/lib/DropDown';
import { Set_DropOff_Inputs, Set_newOrder_draft, Set_Pickup_address, Set_Service_DeliveryMethod } from '../../../Redux/actions/actionNames';
import TooltipOnro from '../../../design-system/lib/Tooltip';
import { INFO_CIRCLE } from '../../../assets';
import clsx from 'clsx';
import { UseCRUDDropoffs } from '../../../hooks/useCRUD_Dropoffs';



function ServicePoint() {
  const { t, i18n } = useTranslation();
  const draft = useSelector((state) => state.NewOrder.newOrder.draft)
  const dispatch = useDispatch();
  const deliveryMethods = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType?.deliveryMethods )
  const activeDeliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod )
  let { items, sEtItems } = UseCRUDDropoffs()



    const handleChange =React.useCallback((item) => {

      if(activeDeliveryMethod && activeDeliveryMethod.dropoffLocationType !== item.dropoffLocationType){
        items.forEach((ddd , i)=>{
                dispatch(
                  Set_DropOff_Inputs({
                    name: "address",
                    value: "",
                    firstDropOff: i == 0,
                    id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
                  })
                );
                dispatch(
                  Set_DropOff_Inputs({
                    name: "idx",
                    value: null,
                    firstDropOff: i == 0,
                    id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
                  })
                );
                dispatch(
                  Set_DropOff_Inputs({
                    name: "name",
                    value: null,
                    firstDropOff: i == 0,
                    id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
                  })
                );
                dispatch(
                  Set_DropOff_Inputs({
                    name: "adresss_loc",
                    value: { lng: "", lat: "" },
                    firstDropOff: i == 0,
                    id: ddd.id == "dropoff" ? "dropoff" : ddd.id,
                  })
                );
        })
      }

      if(activeDeliveryMethod && activeDeliveryMethod.pickupLocationType !== item.pickupLocationType){
        dispatch(
          Set_Pickup_address({
            address: "",
            adresss_loc: { lng: "", lat: "" },
            placeId: "",
            idx:null,
            name:null
          })
        );
      }
      dispatch(Set_Service_DeliveryMethod(item))
    
    }, [activeDeliveryMethod , items]);

if(!deliveryMethods || deliveryMethods.length <= 1) {
  return null
}

  return (
    <div className={styles.CustomerNewOrderContainer}>
      <div className={styles.customerTitleContainer}>
        <IconProvider Icon={DeliveryMethod} size="16"  />
        <Typography  text={t("DeliveryMethod")} weight='Body_Middle_Semibold' style={{fontSize:"13px"}}  />
      </div>

 

 {deliveryMethods.map((item)=>{
  return <div onClick={()=>{handleChange(item)}} className={clsx(styles.DeliveryMethodContainer , (activeDeliveryMethod && activeDeliveryMethod.id == item.id) && styles.DeliveryMethodContainerActive)}>
        <div className={styles.radioBtn}/>
        <Typography weight='Body_Middle_Regular' style={{color:"hsla(0, 0%, 14%, 1)" , fontSize: "13px" , fontWeight:(activeDeliveryMethod && activeDeliveryMethod.id == item.id)  ? "600":"400"}} text={t(item.title)} />
        <TooltipOnro tooltipClassName={styles.TooltipOnro} title={<Typography  style={{padding :"7px 0px"}} weight="Body_Small_Medium" text={item.description} />} placement="right" >
        <img src={INFO_CIRCLE} style={{filter:"grayscale(1)" , width:"12px"}} />
      </TooltipOnro>
    </div>
 })}

    
 

    </div>
  )
}

export default ServicePoint